var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlightDeparture2 = function SvgFlightDeparture2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E1E1E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4.493 14.267A1.667 1.667 0 0 1 2.5 13.092L1.484 9.475a.942.942 0 0 1 1.157-1.142c.161.042.308.126.427.242L4.6 10.142l2.625-.709-1.3-4.875a1.308 1.308 0 0 1 1.637-1.6c.232.068.441.197.605.375l4.225 4.7 3.533-.941a2.067 2.067 0 0 1 2.5 1.216 2 2 0 0 1-.15 1.667 1.98 1.98 0 0 1-1.208.925zM1.666 17.092h16.667"
  })));
};
export default SvgFlightDeparture2;